"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Team = function Team(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M12 9.24259C12.7332 8.88991 13.5414 8.72167 14.3544 8.75253C15.1674 8.78339 15.9605 9.0124 16.6649 9.41965C16.7751 9.48334 16.882 9.55051 16.9855 9.62118C16.8901 8.36431 16.3234 7.18987 15.399 6.33298C14.4745 5.4761 13.2605 5 12 5C10.7395 5 9.52557 5.4761 8.60113 6.33298C7.67669 7.18987 7.11001 8.36431 7.01454 9.62118C7.11799 9.55062 7.22487 9.48344 7.33521 9.41962C8.03952 9.01238 8.83265 8.78337 9.64564 8.75252C10.4586 8.72167 11.2668 8.8899 12 9.24259Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M9.17941 14.128C8.50737 13.6695 7.95755 13.0536 7.57776 12.3341C7.19797 11.6146 6.99972 10.8132 7.00025 9.99962C7.00025 9.87225 7.00501 9.74608 7.01453 9.62109C5.97375 10.3322 5.23997 11.4102 4.96009 12.6392C4.6802 13.8682 4.87487 15.1576 5.50513 16.2493C6.13538 17.3409 7.1547 18.1542 8.35902 18.5263C9.56334 18.8985 10.8638 18.802 12 18.2562C11.8871 18.2019 11.7755 18.1429 11.6651 18.0793C10.9603 17.6729 10.3654 17.1006 9.9322 16.412C9.49898 15.7233 9.24056 14.9393 9.17941 14.128Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.9855 9.62109C16.9949 9.74604 16.9996 9.87222 16.9997 9.99965C17.0002 10.8132 16.802 11.6146 16.4222 12.3341C16.0424 13.0536 15.4926 13.6695 14.8206 14.1281C14.7595 14.9393 14.5011 15.7234 14.0679 16.412C13.6347 17.1006 13.0398 17.673 12.3349 18.0793C12.2246 18.143 12.113 18.202 12 18.2562C13.1362 18.8015 14.4363 18.8976 15.6404 18.5254C16.8444 18.1531 17.8634 17.3399 18.4935 16.2485C19.1236 15.1571 19.3184 13.868 19.0388 12.6392C18.7592 11.4103 18.0259 10.3324 16.9856 9.62109H16.9855Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.75",
    d: "M14.165 11.2498C13.6629 10.3771 12.908 9.67732 12 9.24268C11.18 9.63667 10.483 10.2469 9.9841 11.0077C9.48524 11.7685 9.2034 12.651 9.16895 13.5601C9.1345 14.4692 9.34874 15.3705 9.7886 16.1669C10.2285 16.9633 10.8773 17.6245 11.6651 18.0795C11.7754 18.1432 11.887 18.2022 12 18.2564C12.1129 18.2021 12.2246 18.1431 12.335 18.0795C12.9036 17.7512 13.402 17.3141 13.8017 16.7932C14.2014 16.2723 14.4945 15.6778 14.6645 15.0436C14.8344 14.4094 14.8778 13.748 14.792 13.097C14.7063 12.4461 14.4933 11.8184 14.165 11.2498Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.75",
    d: "M7.33519 9.41972C7.22485 9.48341 7.11797 9.55059 7.01452 9.62128C7.00513 9.74622 7.00037 9.8724 7.00024 9.99981C7.00028 10.9096 7.24855 11.8021 7.71829 12.5812C8.18803 13.3604 8.86146 13.9966 9.66601 14.4213C10.4706 14.846 11.3757 15.0432 12.2841 14.9915C13.1924 14.9399 14.0694 14.6414 14.8206 14.1282C14.8894 13.2211 14.7094 12.3123 14.3 11.4999C13.8906 10.6874 13.2672 10.0021 12.4972 9.51768C11.7271 9.03327 10.8394 8.76816 9.9298 8.7509C9.02018 8.73364 8.1231 8.96488 7.33519 9.41972Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.75",
    d: "M16.9997 9.99982C16.9997 9.87245 16.995 9.74627 16.9855 9.62127C16.882 9.55071 16.7751 9.48354 16.6649 9.41974C15.8769 8.96489 14.9799 8.73364 14.0703 8.7509C13.1606 8.76816 12.273 9.03327 11.5029 9.51767C10.7328 10.0021 10.1094 10.6874 9.70002 11.4999C9.29059 12.3123 9.1106 13.2211 9.17942 14.1282C9.93065 14.6414 10.8076 14.9399 11.7159 14.9915C12.6242 15.0431 13.5294 14.846 14.334 14.4212C15.1385 13.9965 15.8119 13.3603 16.2816 12.5812C16.7514 11.8021 16.9997 10.9096 16.9997 9.99982Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14.165 11.2498C13.663 10.3771 12.9081 9.67732 12 9.24268C11.0929 9.67865 10.3384 10.3782 9.83515 11.2498C9.33193 12.1215 9.10341 13.1246 9.17945 14.1282C10.0106 14.6959 10.9936 14.9995 12.0001 14.9995C13.0065 14.9995 13.9895 14.6959 14.8206 14.1282C14.8983 13.1245 14.6697 12.1208 14.165 11.2498Z",
    fill: props.foregroundColor,
    stroke: "#212121",
    strokeWidth: "0.00347222"
  }));
};

Team.defaultProps = {
  altText: "Team",
  backgroundColor: "#212121",
  foregroundColor: "#FFFFFF"
};
Team.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Team;
exports.default = _default;